const ACCOUNT_SWITCHER = {
    SWITCH_ACCOUNT_BUTTON_CLICKED: {
        event: 'switch_account_button_clicked',
        eventProperties: {
            description:
                'Triggered when a Parent Partner Admin (PPA) clicks the Switch Account button to open the Account Switcher modal',
        },
    },
    SWITCH_ACCOUNT_MODAL_CONFIRMED: {
        event: 'switch_account_modal_confirmed',
        eventProperties: {
            description:
                'Triggered when a PPA confirms a partner account selection in the modal and the view changes to that partner context',
        },
    },
    VIEW_MODE_CHANGED: {
        event: 'view_mode_changed',
        eventProperties: {
            description:
                'Fired when a PPA switches between primary and non-primary account views. Used to determine when a session is in switched mode',
        },
    },
    VIEWING_ACCOUNT_BANNER_VISIBLE: {
        event: 'viewing_account_banner_visible',
        eventProperties: {
            description:
                'Fires when the Currently Viewing Account banner is rendered on screen. Confirms correct visibility while in non-primary mode',
        },
    },
};

export default ACCOUNT_SWITCHER;
